export default __webpack_public_path__ + "static/media/s_gts5.b74bd0df.jpg";